module.exports = __webpack_public_path__ + "img/sound-frecuency.fa260797.svg";